import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';
import { LoginComponent } from './login/login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SidebarComponent } from './sidebar/sidebar.component';
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { SetupAccountComponent } from './setup-account/setup-account.component';
import { RegisterComponent } from './register/register.component';
import { SharedModule } from "../share/shared.module";



@NgModule({
  declarations: [
    HomeComponent,
    LoginComponent,
    SidebarComponent,
    ForgotPasswordComponent,
    SetupAccountComponent,
    RegisterComponent
  ],
  exports: [
    SidebarComponent
  ],
  imports: [
    CommonModule,
    HomeRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    SharedModule
]
})
export class HomeModule { }
